import topLinksJason from '../config/toplinks.json';
import { emptyModal } from './Helpers';
import Model from './Model';

let InfoModal = {
  init: function() {
    renderTopLinks();
    renderAbout();
  },
  openModal: function(type, val) {
    openModal(type, val);
  },
};
let renderTopLinks = function() {
  let container = $('#helpWrapper');
  let topLinkUl = $('<ul>', {
    id: 'topLinkUl',
  }).appendTo(container);
  $.each(topLinksJason.topLinks, function(key, val) {
    // console.log('key:' + key + ' val:' + JSON.stringify(val, null, '\t'));
    $('<li>', {
      class: 'topLink',
      html: val.titel,
      'data-id': key,
    })
      .appendTo(topLinkUl)
      .click(function() {
        openModal('topLink', val);
      });
  });
};
let renderAbout = function() {
  let container = $('#aboutWrapper');
  container.html(
    '<b>' +
      topLinksJason.about.titel +
      '</b><br>' +
      topLinksJason.about.html.short
  );
  $('<div >', {
    id: 'readMoreButton',
    text: 'Læs mere..',
  })
    .appendTo(container)
    .click(function() {
      openModal('readMore');
    });
};
let openModal = function(type, val) {
  emptyModal();
  $('.modal-dialog').addClass('modal-lg topLink');
  let modalTitleDiv = $('#modalTitle');
  let modalBodyDiv = $('.modal-body');
  let modalFooterDiv = $('.modal-footer');
  switch (type) {
    case 'topLink':
      openTopLink(modalTitleDiv, modalBodyDiv, val);
      break;
    case 'readMore':
      openReadMore(modalTitleDiv, modalBodyDiv, modalFooterDiv);
      break;
    case 'modulReadMore':
      console.log('%cmodulReadMore:', 'color:orange;');
      openModulReadMore(modalTitleDiv, modalBodyDiv, val);
      break;
    default:
    //code block
  }
  // $('#contentModal')
  $('#contentModal')
    .modal()
    .on('hidden.bs.modal', function() {
      emptyModal();
    });
};
let openTopLink = function(modalTitleDiv, modalBodyDiv, val) {
  modalTitleDiv.html(
    '<div class="modalHeader1">Kom godt i gang</div><div class="modalHeader2">' +
      val.titel +
      '</div>'
  );
  modalBodyDiv.html(val.body);
  $('<div>', {
    id: 'videoHtml',
    html:
      '<div id="iframeWrapper">' +
      '    <iframe id="player" src="' +
      val.video +
      '" scrolling="no" allowfullscreen="1" mozallowfullscreen="1" webkitallowfullscreen="1" allow="autoplay; fullscreen"></iframe>\n' +
      '</div>',
  }).appendTo(modalBodyDiv);
};
let openReadMore = function(modalTitleDiv, modalBodyDiv, modalFooterDiv) {
  let data = topLinksJason.about;
  modalTitleDiv.html(
    '<div class="modalHeader1">Læs mere</div><div class="modalHeader2">' +
      data.titel +
      '</div>'
  );
  modalBodyDiv.html(data.html.long.replace('\n', '<br><br>'));
  modalFooterDiv.html(
    '<div id="lastUpdate">' +
      Model.versionData.date +
      ' ' +
      Model.versionData.time +
      '</div>'
  );
};

let openModulReadMore = function(modalTitleDiv, modalBodyDiv, data) {
  $('.modal-dialog').addClass('modal-dialog-centered');
  $('.modal-footer').hide();
  modalTitleDiv.html('<div class="modalHeader1">' + data.titel + '</div>');
  modalBodyDiv.html(data.description);
};

export default InfoModal;
